import React from "react";
import line from "../assets/line.png";
import First from "../assets/First.jpg";
import De1 from "../assets/De1.png";
import ColourLogo from "../assets/ColourLogo.svg";
import { Phone, Mail } from "lucide-react";
import { Link } from "react-router-dom";

const Detection = () => {
  return (
    <div className="min-h-screen scroll-smooth">
      {/* Hero Section */}
      <section className="relative h-[60vh] flex items-center justify-center text-white overflow-hidden">
  {/* 🎥 Background Video */}
  <video
    className="absolute top-0 left-0 w-full h-full object-cover z-0"
    src="/Services780.mp4"
    autoPlay
    muted
    loop
    playsInline
  />

  {/* 💜 Overlay */}
  <div className="absolute inset-0 bg-gradient-to-r from-[#0A1B60] via-[#1F2E8A] to-[#4B0FA3] opacity-40 z-10" />

  {/* 📝 Foreground Content */}
  <div className="relative z-20 flex flex-col items-center text-center px-4">

    {/* Main Heading */}
    <h1
      className="
        font-extrabold text-white uppercase
        text-3xl sm:text-5xl md:text-6xl lg:text-7xl
      "
      style={{
        fontFamily: "Calibri, sans-serif",
        letterSpacing: "0.04em",
      }}
    >
      ANOMALY DETECTION
    </h1>

    {/* Sub Heading */}
   <h2
  className="
    uppercase font-extrabold mt-4
    text-white [@media(hover:hover)]:text-transparent
  "
  style={{
    fontFamily: "Calibri, sans-serif",
    WebkitTextStroke: "2px #ffffff",
    fontSize: "3rem",
    lineHeight: "1.1",
    letterSpacing: "0.05em",
  }}
>
  AI-powered pattern recognition
</h2>

  </div>
</section>

      {/* Vision Section */}
      <section className="pt-[100px] pb-12 px-6 bg-white flex flex-col items-center justify-center text-center md:text-left snap-start w-full !h-auto">
       <div className="max-w-6xl w-full mx-auto flex flex-col items-center text-gray-900 text-sm sm:text-base md:text-lg lg:text-[26px] font-normal leading-relaxed space-y-6 sm:space-y-10">
          <p className="max-w-4xl text-center px-2 sm:px-4 leading-[1.5]">
  Our anomaly detection services use intelligent AI/ML models to
  identify unusual patterns across large datasets. Whether in
  healthcare diagnostics, manufacturing systems, or financial
  monitoring, our solution flags risks early, minimizes operational
  disruption, and supports data-driven decisions.
</p>

        </div>
      </section>

      {/* Features Section */}
     <section className="pt-[100px] pb-12 px-6 bg-white flex flex-col items-center justify-center snap-start w-full !h-auto">
        <div className="max-w-6xl w-full mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          {/* Left */}
          <div className="flex flex-col items-start space-y-6">
            <div className="relative inline-block ml-20">
              <h2 className="text-black text-2xl sm:text-3xl md:text-4xl font-semibold">
                Key <span style={{ color: "#0077cc" }}>Features</span>
              </h2>
              <img
                src={line}
                alt="underline"
                className="absolute left-0 -bottom-2 h-[6px] object-contain"
              />
            </div>
            <img
              src={De1}
              alt="Medical Coding illustration"
              className="w-full max-w-xs sm:max-w-sm md:max-w-md object-contain"
            />
          </div>
{/* Right */}
<div className="flex items-center">
  <p
  className="text-gray-700 leading-relaxed text-sm sm:text-base md:text-[26px] text-justify"
  style={{ lineHeight: "1.2" }}
>
  <span className="font-bold text-gray-900">Real-Time Monitoring</span> – Detects anomalies as they happen using live data streams.
  <br />
  <br />
  <span className="font-bold text-gray-900">Cross-Industry Use</span> – Applicable to healthcare, industrial IoT, finance, and more.
  <br />
  <br />
  <span className="font-bold text-gray-900">Advanced Pattern Recognition</span> – Utilizes both supervised and unsupervised learning models.
  <br />
  <br />
  <span className="font-bold text-gray-900">Custom Alerts & Thresholds</span> – Set specific triggers for timely, context-aware notifications.
  <br />
  <br />
  <span className="font-bold text-gray-900">Insightful Analysis</span> – Delivers explanations and context for detected anomalies.
</p>

</div>

        </div>
      </section>

      {/* Why Choose Us */}
     <section className="bg-gradient-to-r from-[#0A0E45] via-[#1E0F78] to-[#4B0EA6] text-white w-full py-12 h-auto flex items-center justify-center">
<div className="max-w-6xl w-full px-6 ml-4 md:ml-20">
          <div className="relative inline-block">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-semibold">
              Why <span style={{ color: "#0077cc" }}>Choose Us</span>
            </h2>
            <img
              src={line}
              alt="underline"
              className="absolute left-0 -bottom-2 h-[6px] w-full object-contain"
            />
          </div>

         <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-12 w-full max-w-4xl mx-auto ml-4 md:ml-12">

            <ul className="space-y-6 list-disc list-inside marker:text-blue-400 text-sm sm:text-base md:text-[26px] leading-relaxed">
              <li className="font-medium transition-transform duration-300 hover:translate-x-2">
                AI-Powered Insights
              </li>
              <li className="font-medium transition-transform duration-300 hover:translate-x-2">
                Domain Expertise
              </li>
              <li className="font-medium transition-transform duration-300 hover:translate-x-2">
                Customizable Models
              </li>
            </ul>
            <ul className="space-y-6 list-disc list-inside marker:text-blue-400 text-sm sm:text-base md:text-[26px] leading-relaxed">
              <li className="font-medium transition-transform duration-300 hover:translate-x-2">
                Early Risk Identification
              </li>
              <li className="font-medium transition-transform duration-300 hover:translate-x-2">
                Scalable Solutions
              </li>
              <li className="font-medium transition-transform duration-300 hover:translate-x-2">
                Secure &amp; Compliant
              </li>
            </ul>
          </div>
        </div>
      </section>
     <section className="relative bg-gradient-to-r from-[#050A3A] via-[#1A0F6B] to-[#3E0E9F] overflow-hidden h-auto">
  {/* White curved part */}
  <div className="absolute top-[180px] left-0 w-full">
  <div className="
    bg-white 
    rounded-t-[12rem] 
    sm:rounded-t-[14rem] 
    h-auto 
    sm:h-[120vh]
    pb-10
  "></div>
</div>
  {/* Content */}
  <div className="relative z-10 px-6 sm:px-10 md:px-16 lg:px-24 pt-24 pb-16">
    {/* Top heading part */}
    <div className="text-center mt-[160px] mb-12">
     <h2
  className="text-4xl sm:text-5xl font-bold mb-2 text-[#6F7DFF]"
>
  Collaborate for Success
</h2>
      <p className="text-gray-700 text-lg sm:text-xl font-medium">
        Working together with others fosters innovation, creativity, and a greater sense of accomplishment.
      </p>
    </div>

    {/* Four-column footer part */}
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 text-gray-800">
      {/* About Us */}
      <div>
        <h3 className="font-bold mb-4 text-gray-900">ABOUT US</h3>
        <img src={ColourLogo} alt="Wissenstil Solutions" className="w-40 mb-4" />
      <p className="mb-4 leading-relaxed">
  Wissenstil Solutions is a specialized software company driving digital innovation.
</p>
      </div>

      {/* Services */}
      <div>
        <h3 className="font-bold mb-4 text-gray-900">SERVICES</h3>
        <ul className="space-y-2">
          <li>Image Analysis</li>
          <li>Anomaly Detection</li>
          <li>Medical Coding</li>
        </ul>
      </div>

  
{/* Useful Links */}
<div>
  <h3 className="font-bold mb-4 text-gray-900">USEFUL LINKS</h3>
  <ul
    className="space-y-2 text-gray-800"
    style={{ fontFamily: 'Calibri, sans-serif' }}
  >
    {[
      { name: "About Us", path: "/about" },
      { name: "Wise Services", path: "/services" },
      { name: "Wise Products", path: "/products" },
      { name: "Contact Us", path: "/contact" },
    ].map((link, index) => (
      <li
        key={index}
        className="transition-transform duration-300 hover:translate-x-2 text-base sm:text-lg md:text-xl"
      >
        <Link
          to={link.path}
          onClick={() => (window.location.href = link.path)}
          className="relative inline-block hover:text-purple-700 transition-colors duration-200 after:content-[''] after:absolute after:left-0 after:bottom-0 after:w-0 after:h-[2px] after:bg-purple-700 hover:after:w-full after:transition-all after:duration-300"
        >
          {link.name}
        </Link>
      </li>
    ))}
  </ul>
</div>

      {/* Contact */}
      <div>
        <h3 className="font-bold mb-4 text-gray-900">CONTACT US</h3>
        <p>
          Wissenstil Solutions Private Ltd.<br />
          Brigade IRV Centre, 09th &amp; 10th Floor,<br />
          Nallurahalli, Whitefield,<br />
          Bangalore, 560066.
        </p>
     

<div className="mt-4 space-y-3 text-white">
  <p className="flex items-center space-x-3">
    <Phone className="w-5 h-5 text-gray-900" />
    <span className="text-gray-900 font-medium">+91 9986158307</span>
  </p>
  <p className="flex items-center space-x-3">
    <Mail className="w-5 h-5 text-gray-900" />
    <span className="text-gray-900 font-medium">Manish.palliyil@wissenstil.com</span>
  </p>
</div>
      </div>
    </div>
  </div>
</section>


    </div>
  );
};

export default Detection;